(function () {
  function getActivePanel(section) {
    return section.querySelector('.ff-tab-products__panel.is-active');
  }

  function getActiveTrack(section) {
    const panel = getActivePanel(section);
    return panel ? panel.querySelector('[data-ff-tab-track]') : null;
  }

  function activateTab(section, tabId) {
    const tabs = section.querySelectorAll('[data-ff-tab-trigger]');
    const panels = section.querySelectorAll('[data-ff-tab-panel]');
    const viewAll = section.querySelector('[data-ff-tab-view-all]');

    tabs.forEach((tab) => {
      const isActive = tab.dataset.tabId === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.tabId === tabId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (viewAll && viewAll.dataset.ffTabViewAllFixed !== 'true') {
      const activeTab = section.querySelector(`[data-ff-tab-trigger][data-tab-id="${tabId}"]`);
      if (activeTab && activeTab.dataset.collectionUrl) {
        viewAll.href = activeTab.dataset.collectionUrl;
      }
    }
  }

  function scrollTrack(section, direction) {
    const track = getActiveTrack(section);
    if (!track) return;

    const item = track.querySelector('.ff-product-showcase__item');
    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    const amount = item ? item.offsetWidth + gap : track.clientWidth * 0.85;

    track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  function initTabProducts(section) {
    if (!section || section.dataset.ffTabInit === 'true') return;
    section.dataset.ffTabInit = 'true';

    section.querySelectorAll('[data-ff-tab-trigger]').forEach((tab) => {
      tab.addEventListener('click', () => {
        activateTab(section, tab.dataset.tabId);
      });
    });

    const prevBtn = section.querySelector('[data-ff-tab-prev]');
    const nextBtn = section.querySelector('[data-ff-tab-next]');

    prevBtn?.addEventListener('click', () => scrollTrack(section, -1));
    nextBtn?.addEventListener('click', () => scrollTrack(section, 1));
  }

  function initAll(root) {
    (root || document).querySelectorAll('.ff-tab-products').forEach(initTabProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.ff-tab-products') || event.target;
    if (section?.classList?.contains('ff-tab-products')) {
      delete section.dataset.ffTabInit;
      initTabProducts(section);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.querySelector?.('.ff-tab-products');
    const blockId = event.detail?.blockId;
    if (section && blockId) {
      activateTab(section, blockId);
    }
  });
})();
